import { BlockingView } from "./blocking-view/blocking-view2.js";
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/layout/layout.tsx
var Article = ({ children, className, isPending }) => /* @__PURE__ */ jsx(BlockingView, {
	className: classNames(className, "article"),
	component: "article",
	isPending,
	children
});
var Aside = ({ children, className, isPending, testId, id }) => /* @__PURE__ */ jsx(BlockingView, {
	className: classNames(className, "aside"),
	component: "aside",
	isPending,
	testId,
	id,
	children
});
var Header = ({ children, className, isPending, testId }) => /* @__PURE__ */ jsx(BlockingView, {
	className: classNames(className, "header"),
	component: "header",
	isPending,
	testId,
	children
});
var Footer = ({ children, className, isPending, testId }) => /* @__PURE__ */ jsx(BlockingView, {
	className: classNames(className, "footer"),
	component: "footer",
	isPending,
	testId,
	children
});
var Layout = ({ children, className, isPending, testId }) => /* @__PURE__ */ jsx(BlockingView, {
	className: classNames(className, "layout"),
	component: "div",
	isPending,
	testId,
	children
});
var Main = ({ children, className, isPending }) => /* @__PURE__ */ jsx(BlockingView, {
	className: classNames(className, "main"),
	component: "main",
	isPending,
	children
});
var Navigation = ({ children, className, isPending }) => /* @__PURE__ */ jsx(BlockingView, {
	className: classNames(className, "navigation"),
	component: "nav",
	isPending,
	children
});
var Section = ({ children, className, isPending, testId, id }) => /* @__PURE__ */ jsx(BlockingView, {
	className: classNames(className, "section"),
	component: "section",
	isPending,
	testId,
	id,
	children
});
var Container = ({ children, className, isPending, testId, id, loadingText }) => /* @__PURE__ */ jsx(BlockingView, {
	className: classNames(className),
	component: "div",
	isPending,
	testId,
	id,
	loadingText,
	children
});
//#endregion
export { Article, Aside, Container, Footer, Header, Layout, Main, Navigation, Section };

//# sourceMappingURL=layout.js.map